<!--
  Author: Gary Hammock
  Version: 0.1.0
  Description: A page/view to enumerate publications.

  Requires: PublicationRenderer
-->

<template>
  <article class="publications">
    <h1 class="border-bottom">
      Publications
    </h1>
    <publication-renderer
      v-for="(pub, index) in publications"
      :key="index"
      :authors="pub.author"
      :title="pub.title"
      :year="pub.year"
      :month="pub.month"
      :volume="pub.volume"
      :pages="pub.pages"
      :conference="pub.conference"
      :publisher="pub.publisher"
      :paper-number="pub.paperNumber"
      :publication-location="pub.publicationLocation"
      :publication-date="pub.publicationDate"
      :doi="pub.doi"
      :url="pub.url"
      class="my-4"
    />
  </article>
</template>

<script>
// The publication source information.
import publications from './publications.json'

// First-party imports.
import PublicationRenderer from '../components/PublicationRenderer'

export default {
  name: 'PagePublications',

  components: {
    PublicationRenderer
  },

  data () {
    return {
      publications: publications
    }
  }
}
</script>
